import { Check } from 'lucide-react';

import type { SanityComparisonCards } from '#/lib/sanity/queries/comparisonCards';
import { Link } from '#/components/Link';

import { RichText } from './RichText';

const List = ({
  features,
}: {
  features: SanityComparisonCards['cards'][number]['features'];
}) => {
  return (
    <ul className="text-grayscale-06 text-14">
      {features.map((feature) => (
        <li key={feature._key} className="flex items-center  gap-10">
          <Check width={16} height={16} />
          <RichText
            value={feature.featureText}
            normalTextSizeClassName={'text-14 font-300'}
          />
        </li>
      ))}
    </ul>
  );
};

const Content = ({
  card,
}: {
  card: SanityComparisonCards['cards'][number];
}) => {
  return (
    <>
      {card.badge && (
        <span className="w-max inline-flex items-center rounded-full py-2 border border-current px-17 font-440 text-14">
          {card.badge}
        </span>
      )}
      <h3 className="text-34 font-[440] leading-100 max-w-[20ch]">
        {card.title}
      </h3>
      <p className="text-grayscale-06 text-16 ">{card.description}</p>
    </>
  );
};

export function ComparisonCards(props: SanityComparisonCards) {
  return (
    <div className="p-main">
      <section className="max-w-984 mx-auto">
        <div className="container mx-auto px-4">
          {/* Title */}
          <div className="text-center mb-48 m:mb-80">
            {props.eyebrow && (
              <span className="font-azeret text-12 uppercase leading-150 tracking-5 text-grayscale-06 mb-10 block mx-auto">
                {props.eyebrow}
              </span>
            )}
            <h2 className="text-32 m:text-50 text-charcoal font-[440] mx-auto  leading-100 text-balance m:text-wrap m:max-w-[21ch]">
              {props.title}
            </h2>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-28">
            {props.cards.map((card, index) => {
              const isLastCard = index === 2 && props.cards.length === 3;
              if (isLastCard) {
                return (
                  <div
                    className="bg-grayscale-01 rounded-25 px-25 py-30 grid m:grid-cols-2 text-charcoal m:col-span-2 gap-24"
                    key={card._key}
                  >
                    <div className="flex gap-24 flex-col flex-1 ">
                      <Content card={card} />
                    </div>
                    <List features={card.features} />
                  </div>
                );
              }
              return (
                <div
                  key={card._key}
                  className="bg-cipher-01 rounded-25 px-25 py-30 flex flex-col text-charcoal"
                >
                  <div className="flex gap-24 flex-col m:mb-60 mb-40">
                    <Content card={card} />
                    <List features={card.features} />
                  </div>

                  <Link
                    className="mt-auto w-max btn-charcoal"
                    href={card?.cta?.href}
                  >
                    {card?.cta?.title}
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
